module.exports = __webpack_public_path__ + "img/aliwangwang.9eccf854.svg";